import React, { useEffect } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionNotification,
  SectionNotificationType,
} from 'wix-ui-tpa/cssVars';
import { bookingsUoUBookingFormClickSrc16Evid83 } from '@wix/bi-logger-bookings-data/v2';
import { useFormActions } from '../../Hooks/useFormActions';
import {
  BookingFormClickActions,
  BookingFormClickComponents,
} from '../../../../types/biLoggerTypes';
import { classes } from './ParticipantsClearedNotification.st.css';
import { ParticipantsClearedNotificationDataHooks } from './dataHooks';

const PARTICIPANTS_CLEARED_MESSAGE_KEY =
  'bookings.form.collectParticipant.loggedIn.otherParticipantsRemoved';

export const ParticipantsClearedNotification: React.FC = () => {
  const { t } = useTranslation();
  const { logBi } = useFormActions();

  useEffect(() => {
    logBi([
      bookingsUoUBookingFormClickSrc16Evid83({
        component: BookingFormClickComponents.ParticipantsCleared,
        action: BookingFormClickActions.Load,
      }),
    ]);
  }, [logBi]);

  return (
    <div className={classes.root}>
      <SectionNotification
        type={SectionNotificationType.default}
        data-hook={ParticipantsClearedNotificationDataHooks.MESSAGE}
      >
        <SectionNotification.Text>
          {t(PARTICIPANTS_CLEARED_MESSAGE_KEY)}
        </SectionNotification.Text>
      </SectionNotification>
    </div>
  );
};
